import type { BeneficialOwnershipSpecificMetadata } from '@gcv/shared';

// This function takes a text string and a record of interpolation values,
// and replaces placeholders in the text with the corresponding values from the record.
export const interpolateValuesInText = (
  text?: string,
  interpolationValues?: BeneficialOwnershipSpecificMetadata
): string => {
  if (!text) return '';

  return Object.entries(interpolationValues || {}).reduce((acc, [key, value]) => {
    const placeholder = `{{${key}}}`;
    return acc.replace(new RegExp(placeholder, 'g'), String(value));
  }, text);
};
